import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { orderedPractitionerTypes, TypeBehandelaar } from '@common/customControls/bariatrics';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariatricsExternalReferralData = {
    assets: ProcessActivityAsset[];
    datum_verwijzing: string | null;
    naam_externe_behandelaar: string | null;
    reden_doorverwijzing: string | null;
    type_behandelaar: TypeBehandelaar | null;
    type_behandelaar_overig: string | null;
};

const bariatricsExternalReferralFinal: TypedSchema<BariatricsExternalReferralData> = {
    assets: getProcessActivityAssetsSchema({ min: 1 }),
    datum_verwijzing: Koi.koi().todayOrBefore(),
    naam_externe_behandelaar: getTextAreaStringSchema(),
    reden_doorverwijzing: getTextAreaStringSchema(),
    type_behandelaar: Koi.valid(...orderedPractitionerTypes),
    type_behandelaar_overig: Koi.when('type_behandelaar', {
        is: TypeBehandelaar.overig,
        otherwise: Koi.valid(null),
        then: getTextAreaStringSchema(),
    }),
};

const bariatricsExternalReferralDraft = addAllowNull(
    {
        ...bariatricsExternalReferralFinal,
        assets: getProcessActivityAssetsSchema(),
    },
    ['assets']
);

export const bariatricsExternalReferralDraftSchema = Koi.object(bariatricsExternalReferralDraft);
export const bariatricsExternalReferralFinalSchema = Koi.object(bariatricsExternalReferralFinal);

export type BariatricsExternalReferralReadKey = keyof BariatricsExternalReferralData;

export type BariatricsExternalReferralReadLabel =
    | 'Datum verwijzing'
    | 'Naam externe behandelaar'
    | 'Reden doorverwijzing'
    | 'Type behandelaar'
    | 'Verwijsbrief';

export const bariatricsExternalReferralReadSchema: TypedReadSchema<
    BariatricsExternalReferralReadKey,
    BariatricsExternalReferralReadLabel
>[] = [
    {
        items: [
            {
                key: 'assets',
                label: 'Verwijsbrief',
            },
            {
                key: 'datum_verwijzing',
                label: 'Datum verwijzing',
                type: 'dateAsString',
            },
            {
                key: 'type_behandelaar',
                label: 'Type behandelaar',
            },
            {
                key: 'naam_externe_behandelaar',
                label: 'Naam externe behandelaar',
            },
            {
                key: 'reden_doorverwijzing',
                label: 'Reden doorverwijzing',
            },
        ],
    },
];
